import { CountryModel } from '@core/data-access';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { BusinessClassification, CompanyType } from '../type';

export const PERSONNEL_OTHER = 'PERSONNEL_OTHER' as const;

export const BUSINESS_CLASSIFICATION = [
  'SOLE_PROPRIETORSHIP',
  'PARTNERSHIP',
  'LIMITED_PARTNERSHIP',
  'LIMITED_LIABILITY_PARTNERSHIP',
  'EXEMPT_PRIVATE_COMPANY',
] as const;

export const COMPANY_TYPE = [
  'PUBLIC_COMPANY_LIMITED_BY_SHARES',
  'PUBLIC_COMPANY_LIMITED_BY_GUARANTEE',
  'UNLIMITED_PUBLIC_COMPANY',
  'PRIVATE_COMPANY_LIMITED_BY_SHARES',
  'EXEMPT_PRIVATE_COMPANY_LIMITED_BY_SHARES',
  'UNLIMITED_PRIVATE_COMPANY',
  'UNLIMITED_EXEMPT_PRIVATE_COMPANY',
  'FOREIGN_COMPANY_REGISTERED_IN_SINGAPORE',
] as const;

// TODO: using mapCountriesToFormlySelectOption function instead of initCountryOptions
export function initCountryOptions(countries: CountryModel[] | null): FormlySelectOption[] {
  return countries?.map(o => ({ label: o.name, value: o.id })) || [];
}

export const BusinessClassificationEntries: { [k in BusinessClassification]: string } = {
  SOLE_PROPRIETORSHIP: 'Sole-Proprietorship',
  PARTNERSHIP: 'Partnership',
  LIMITED_PARTNERSHIP: 'Limited Partnership',
  LIMITED_LIABILITY_PARTNERSHIP: 'Limited Liability Partnership',
  EXEMPT_PRIVATE_COMPANY: 'Exempt Private Company',
};

export const CompanyTypeEntries: { [k in CompanyType]: string } = {
  PUBLIC_COMPANY_LIMITED_BY_SHARES: 'Public Company Limited by Shares',
  PUBLIC_COMPANY_LIMITED_BY_GUARANTEE: 'Public Company Limited by Guarantee',
  UNLIMITED_PUBLIC_COMPANY: 'Unlimited Public Company',
  PRIVATE_COMPANY_LIMITED_BY_SHARES: 'Private Company Limited by Shares',
  EXEMPT_PRIVATE_COMPANY_LIMITED_BY_SHARES: 'Exempt Private Company Limited by Shares',
  UNLIMITED_PRIVATE_COMPANY: 'Unlimited Private Company',
  UNLIMITED_EXEMPT_PRIVATE_COMPANY: 'Unlimited Exempt Private Company',
  FOREIGN_COMPANY_REGISTERED_IN_SINGAPORE: 'Foreign Company Registered in Singapore',
};

export const initCompanyTypeOptions = (): FormlySelectOption[] => {
  return Object.entries(CompanyTypeEntries).map<FormlySelectOption>(([k, v]) => ({
    label: v,
    value: k,
  }));
};

export const initBusinessClassificationOptions = (): FormlySelectOption[] => {
  return Object.entries(BusinessClassificationEntries).map<FormlySelectOption>(([k, v]) => ({ label: v, value: k }));
};

export const otherPersonnelOption: FormlySelectOption = {
  label: 'Other',
  value: PERSONNEL_OTHER,
  disabled: false,
} as const;
